"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/heroSection.tsx */

import { HeaderSectionProps } from "@/Templates/SectionsProps";
import GeneratedHeaderSection from "../../Components/GeneratedHeaderSection";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HeroSectionCounterFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Patients" | "Specialists" */
    p0Text: ReactNode;
    /** Detected variants: "Successfully Recovered" | "Committed to Patient" */
    span0Text: ReactNode;
    /** Detected variants: "counter-item wow fadeInUp" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "+" */
    h20Text?: ReactNode;
    /** Detected variants: "count" */
    h20ClassName?: string;
    /** Detected variants: "count-digit" */
    span0ClassName?: string;
    /** Detected variants: "isVisible && <CountUp end={500} duration={2} />" | "isVisible && <CountUp end={300} duration={2} />" */
    h20span0Expr0: ReactNode;
};

type HeroSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Reclaim Your Life" | "Move Without Pain" | "Return to What You Love" */
    h20Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h20ClassName?: string;
};
export type HomeEighteenHeroSectionGeneratedProps = {
    headerSectionProps?: HeaderSectionProps;
    divDiv0Div0Div0ClassName?: string;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div0Div0A0AHref?: string;
    /** Default: "Schedule Free Consultation" */
    divDiv0Div0Div0Div0Div0Div0A0AText?: ReactNode;
    /** Default: "tel:1234567890" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1A0AHref?: string;
    /** Default: "+1 24565 89856" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1A0AText?: ReactNode;
    /** Default: "General Enquiry" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div0H10H1DataWowDuration?: string;
    divDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Recover Your" */
    divDiv0Div0Div0Div0Div0H10Span0Span0SpanText?: ReactNode;
    /** Default: "Precious" */
    divDiv0Div0Div0Div0Div0H10Span1Span0SpanText?: ReactNode;
    /** Default: "Movement" */
    divDiv0Div0Div0Div0Div0H10Span2Span0SpanText?: ReactNode;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div0P0PDataWowDuration?: string;
    /** Default: "Expert physiotherapy and rehabilitation services designed to restore your mobility, relieve pain, and accelerate your recovery journey." */
    divDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    divDiv0Div0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-01.png" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-01.png" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageSrc?: string;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-6.png" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionCounterFadeInUpsItem) => Partial<ComponentProps<"h2">>);
    heroSectionServicesSlidesDivH20H2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "shadow" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-2.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-3.png" */
    divImageWithBasePath1ImageSrc?: string;
    divImageWithBasePath1ImageVisible?: boolean;
    divImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-4.png" */
    divImageWithBasePath2ImageSrc?: string;
    divImageWithBasePath2ImageVisible?: boolean;
    divImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-5.png" */
    divImageWithBasePath3ImageSrc?: string;
    divImageWithBasePath3ImageVisible?: boolean;
    divImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    divSection0SectionDataWowDuration?: string;
    /** Default: "down" */
    divSection0Div0DivDataDirection?: string;
    /** Default: "fast" */
    divSection0Div0DivDataSpeed?: string;
    heroSectionCounterFadeInUps: HeroSectionCounterFadeInUpsItem[];
    heroSectionServicesSlides: HeroSectionServicesSlidesItem[];
    heroSectionCounterFadeInUpsItemWrapper?: (item: HeroSectionCounterFadeInUpsItem, content: ReactNode) => ReactNode;
    heroSectionCounterFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionCounterFadeInUpsH2Visible?: boolean;
    heroSectionCounterFadeInUpsH2Renderer?: (item: HeroSectionCounterFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    heroSectionCounterFadeInUpsH2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionCounterFadeInUpsItem) => Partial<ComponentProps<"h2">>);
    heroSectionServicesSlidesItemWrapper?: (item: HeroSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    heroSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionServicesSlidesH2Visible?: boolean;
    heroSectionServicesSlidesH2Renderer?: (item: HeroSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    heroSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeEighteenHeroSectionGenerated: FC<HomeEighteenHeroSectionGeneratedProps> = ({
    headerSectionProps,
    divDiv0Div0Div0Div0Div0Div0A0AHref = "#",
    divDiv0Div0Div0Div0Div0Div0A0AText = "Schedule Free Consultation",
    divDiv0Div0Div0Div0Div0Div0Div0Div1A0AHref = "tel:1234567890",
    divDiv0Div0Div0Div0Div0Div0Div0Div1A0AText = "+1 24565 89856",
    divDiv0Div0Div0Div0Div0Div0Div0Div1P0PText = "General Enquiry",
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration = "1s",
    divDiv0Div0Div0Div0Div0H10H1DataWowDuration = "1s",
    divDiv0Div0Div0Div0Div0H10H1Visible,
    divDiv0Div0Div0Div0Div0H10H1Renderer,
    divDiv0Div0Div0Div0Div0H10H1Props,
    divDiv0Div0Div0Div0Div0H10Span0Span0SpanText = "Recover Your",
    divDiv0Div0Div0Div0Div0H10Span1Span0SpanText = "Precious",
    divDiv0Div0Div0Div0Div0H10Span2Span0SpanText = "Movement",
    divDiv0Div0Div0Div0Div0P0PDataWowDuration = "1s",
    divDiv0Div0Div0Div0Div0P0PText = "Expert physiotherapy and rehabilitation services designed to restore your mobility, relieve pain, and accelerate your recovery journey.",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt = "banner-img",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-01.png",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageAlt = "banner-img",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-img-01.png",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageVisible,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageRenderer,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageProps,
    divDiv0Div0Div0Div1Div0DivDataWowDuration = "1s",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "shadow",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-6.png",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    divImageWithBasePath0ImageAlt = "shadow",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-2.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath1ImageAlt = "shadow",
    divImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-3.png",
    divImageWithBasePath1ImageVisible,
    divImageWithBasePath1ImageRenderer,
    divImageWithBasePath1ImageProps,
    divImageWithBasePath2ImageAlt = "shadow",
    divImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-4.png",
    divImageWithBasePath2ImageVisible,
    divImageWithBasePath2ImageRenderer,
    divImageWithBasePath2ImageProps,
    divImageWithBasePath3ImageAlt = "shadow",
    divImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-5.png",
    divImageWithBasePath3ImageVisible,
    divImageWithBasePath3ImageRenderer,
    divImageWithBasePath3ImageProps,
    divSection0Div0DivDataDirection = "down",
    divSection0Div0DivDataSpeed = "fast",
    divSection0SectionDataWowDuration = "1s",
    divH20H2Props,
    heroSectionServicesSlidesDivH20H2Props,
    divDiv0Div0Div0ClassName,
    heroSectionCounterFadeInUps,
    heroSectionServicesSlides,
    heroSectionCounterFadeInUpsItemWrapper,
    heroSectionCounterFadeInUpsRenderer,
    heroSectionCounterFadeInUpsH2Visible,
    heroSectionCounterFadeInUpsH2Renderer,
    heroSectionCounterFadeInUpsH2Props,
    heroSectionServicesSlidesItemWrapper,
    heroSectionServicesSlidesRenderer,
    heroSectionServicesSlidesH2Visible,
    heroSectionServicesSlidesH2Renderer,
    heroSectionServicesSlidesH2Props,
}) => {
    return (
        <div className="hero-section-eighteen">
            {headerSectionProps?.pageData ? <GeneratedHeaderSection pageData={headerSectionProps.pageData} setting={{ Appearance: { Id: -1, Name: "Home18", Key: CenterOptions.SiteTemplate.SiteTemplateSettings.SiteTemplateHeroAppearance.Home18.key, Priority: -1 }, HeroImage: { Id: -1, Name: "", Size: 0 }, HeroButtonDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoImage: { Id: -1, Name: "", Size: 0 }, HeroVideoLink: { Id: -1, Name: "", Size: 0 } }} lists={{ HeroAvatars: [], HeroStatistics: [], SideImages: [] }} /> : null}
            <div className="banner-section-eighteen">
                <div className="container">
                    <div className={divDiv0Div0Div0ClassName ?? "row row-gap-4 align-items-center"}>
                        <div className="col-lg-6">
                            <div className="banner-content">
                                {renderNode(divDiv0Div0Div0Div0Div0H10H1Visible, divDiv0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="title wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0H10H1DataWowDuration} {...(divDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        <span className="one">
                                            <span className="text">{divDiv0Div0Div0Div0Div0H10Span0Span0SpanText}</span>
                                        </span>
                                        <span className="two">
                                            <span className="text">{divDiv0Div0Div0Div0Div0H10Span1Span0SpanText}</span>
                                        </span>
                                        <span className="three">
                                            <span className="text">{divDiv0Div0Div0Div0Div0H10Span2Span0SpanText}</span>
                                        </span>
                                    </h1>
                                ))}
                                <p className="description wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0P0PDataWowDuration}>{divDiv0Div0Div0Div0Div0P0PText}</p>
                                <div className="banner-link wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0Div0DivDataWowDuration}>
                                    <a href={divDiv0Div0Div0Div0Div0Div0A0AHref} className="theme-18-btn">
                                        <span className="icon">
                                            <i className="isax isax-calendar5"></i>
                                        </span>
                                        {" "}
                                        {divDiv0Div0Div0Div0Div0Div0A0AText}
                                        {" "}
                                    </a>
                                    <div className="banner-support">
                                        <div className="banner-icon">
                                            <i className="isax isax-call-calling"></i>
                                        </div>
                                        <div className="banner-support-content">
                                            <p className="sub-title">{divDiv0Div0Div0Div0Div0Div0Div0Div1P0PText}</p>
                                            <a href={divDiv0Div0Div0Div0Div0Div0Div0Div1A0AHref} className="link">{divDiv0Div0Div0Div0Div0Div0Div0Div1A0AText}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img wow zoomIn" data-wow-duration={divDiv0Div0Div0Div1Div0DivDataWowDuration}>
                                <div className="banner-img-wrap">
                                    {renderNode(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid banner-img-1" {...(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {renderNode(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageVisible, divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageRenderer, (
                                        <SmartImage src={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageSrc} alt={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid banner-img-reveal" style={{ clipPath: "circle(0px at 50% 50%)" }} {...(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                                    ))}
                                </div>
                                {renderNode(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                <div className="banner-count">
                                    {renderCollectionNode(
                                        heroSectionCounterFadeInUps,
                                        (item: HeroSectionCounterFadeInUpsItem) => (
                                            <div className={item.className ?? "counter-item wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                                {renderItemNode(heroSectionCounterFadeInUpsH2Visible, heroSectionCounterFadeInUpsH2Renderer, item, (
                                                    <h2 className={item.h20ClassName ?? "count"} {...(typeof heroSectionCounterFadeInUpsH2Props === "function" ? heroSectionCounterFadeInUpsH2Props(item) : (heroSectionCounterFadeInUpsH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                                        <span className={item.span0ClassName ?? "count-digit"}></span>
                                                        {item.h20Text ?? "+"}
                                                    </h2>
                                                ))}
                                                <p>
                                                    {item.p0Text}
                                                    <span>{item.span0Text}</span>
                                                </p>
                                            </div>
                                        ),
                                        heroSectionCounterFadeInUpsItemWrapper,
                                        heroSectionCounterFadeInUpsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="slider-section-eighteen three wow fadeInDown" data-wow-duration={divSection0SectionDataWowDuration}>
                <div className="vertical-slide slide-eighteen d-flex" data-direction={divSection0Div0DivDataDirection} data-speed={divSection0Div0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            heroSectionServicesSlides,
                            (item: HeroSectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(heroSectionServicesSlidesH2Visible, heroSectionServicesSlidesH2Renderer, item, (
                                        <h2 className={item.h20ClassName ?? "title"} {...(typeof heroSectionServicesSlidesH2Props === "function" ? heroSectionServicesSlidesH2Props(item) : (heroSectionServicesSlidesH2Props ?? {}))} {...(typeof heroSectionServicesSlidesDivH20H2Props === "function" ? heroSectionServicesSlidesDivH20H2Props(item) : (heroSectionServicesSlidesDivH20H2Props ?? {}))}>{item.h20Text}</h2>
                                    ))}
                                </div>
                            ),
                            heroSectionServicesSlidesItemWrapper,
                            heroSectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
            </section>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="shadow-1" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath1ImageVisible, divImageWithBasePath1ImageRenderer, (
                <SmartImage src={divImageWithBasePath1ImageSrc} alt={divImageWithBasePath1ImageAlt} className="shadow-2" {...(divImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath2ImageVisible, divImageWithBasePath2ImageRenderer, (
                <SmartImage src={divImageWithBasePath2ImageSrc} alt={divImageWithBasePath2ImageAlt} className="shadow-3 d-none" {...(divImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath3ImageVisible, divImageWithBasePath3ImageRenderer, (
                <SmartImage src={divImageWithBasePath3ImageSrc} alt={divImageWithBasePath3ImageAlt} className="shadow-4" {...(divImageWithBasePath3ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeEighteenHeroSectionGenerated;
